import { render, staticRenderFns } from "./PrizePicture.vue?vue&type=template&id=c1dd1472&scoped=true&"
import script from "./PrizePicture.vue?vue&type=script&lang=js&"
export * from "./PrizePicture.vue?vue&type=script&lang=js&"
import style0 from "./PrizePicture.vue?vue&type=style&index=0&id=c1dd1472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1dd1472",
  null
  
)

export default component.exports